export const PromptDigitalIDPassword = {
  "Title": "Digital ID Authentication",
  "Desc": "Access to your digital ID is required to open an encrypted document.",
  "DigitalIDInfo": "Digital ID Information:",
  "Issuer": "Issuer:",
  "Email": "Email:",
  "Password": "Password:",
  "ErrorPassword": "Passwords do not match.",
  "ErrorOpenNoRight": "You do not have access rights to this encrypted document."
}